export default {
  title: 'Ajouter une carte de crédit',
  buttons: {
    save: 'Enregistrer',
  },
  feedback: {
    success: 'Carte ajoutée avec succès',
  },
};
